const Blue = {
    title: 'Blue',
    background: 'radial-gradient(circle, #8EA7E9 0%, #7286D3 100%)',
    colors: {
        primary: '#7286D3',
        secondary: '#7999D9',
        terciary: '#8EA7E9',
        fourth: 'rgb(215, 215, 255)',
        fifth: '#E5E0FF'
    }
};

export default Blue;